<template>
  <div class="review-box">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>买家信息</span>
      </div>
      <div class="text item">
        <ul>
          <li class="mgb15">账号ID/微信名称：{{ detailData.afterSaleName }}</li>
          <li class="mgb15">手机号码：{{ detailData.afterSaleMobile }}</li>
          <li class="mgb15">商品名称：{{ orderDetail.orderItems[0].productSkuName}}</li>
          <li class="mgb15">子订单号：{{ detailData.orderNo }}</li>
          <li>下单时间：{{orderDetail.creationTime}}</li>
          <!--          <li>换货地址：姓名/手机号/详细地址</li>-->
        </ul>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>操作说明</span>
      </div>
      <div class="text item">
        <div class="mgb15">
          <span class="mgr40">类型：{{ detailData.afterSaleType == 1 ? '退款' : detailData.afterSaleType == 2 ? '退货' : '换货' }}</span>
          <span>当前订单状态：
            <span v-if="orderDetail.status == 0">创建订单</span>
            <span v-if="orderDetail.status == 1">支付成功</span>
            <span v-if="orderDetail.status == 2">待发货</span>
            <span v-if="orderDetail.status == 3">已发货</span>
            <span v-if="orderDetail.status == 4">订单完成</span>
          </span>
        </div>
        <div class="mgb15">
          <span class="mgr40">需退款数量：{{ detailData.afterSaleQuantity }}</span>
          <span>需退款金额：￥{{ detailData.afterSaleAmount }}</span>
        </div>
        <div style="padding-top:10px;">
          <div style="margin-bottom:10px;">备注</div>
          <el-input v-model="remark" type="textarea"></el-input>
        </div>
      </div>
    </el-card>
    <div class="btn-box">
      <el-button type="primary" @click="save">确认</el-button>
    </div>
  </div>
</template>

<script>
import {
  OrderAfterSaleGet,
  OrderPurchaseGet,
  OrderAfterSaleConfirm
} from '../../../api/api'

export default {
  name: 'BackMoney',
  data() {
    return {
      id: null,
      orderId: null,
      detailData: {},
      orderDetail: {},
      remark: '',
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.orderId = this.$route.query.orderid
      this.getDetail(this.$route.query.id)
      this.getOrderDetail()
    } else {
      return this.$message.error('缺少售后单Id,参数缺失')
    }
  },
  methods: {
    save() {
      this.$confirm("确认提交保存吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(async () => {
        let params = {};
        params.afterSaleRemark = this.remark;
        params.orderAfterSaleId = this.detailData.id;
        let res = await OrderAfterSaleConfirm(params);
        if (res.data.success) {
          this.$message.success(res.data.msg || '保存成功');
        } else {
          this.$message.error(res.data.error.message || '保存失败, 请重试');
        }
      }).catch(() => {
      });
    },
    async getDetail(params) {
      let res = await OrderAfterSaleGet({id: this.id})
      if (res.data.success) {
        this.detailData = res.data.result || {}
      } else {
        this.$message.error(res.data.error || '获取失败,请重试')
      }

    },
    getOrderDetail() {
      OrderPurchaseGet({id: this.orderId}).then(res => {
        if (res.data.success) {
          this.orderDetail = res.data.result || {}
        } else {
          this.$message.error(res.data.error.message);
        }
      })
    },
  }
}
</script>

<style scoped>
.review-box {
  padding: 0 20px;
}

.box-card {
  margin-bottom: 20px;
}

.clearfix {
  font-size: 16px;
  font-weight: 700;
}

.mgb15 {
  margin-bottom: 15px;
}

.mgr40 {
  margin-right: 40px;
}

.total-box {
  margin-top: 15px;
  text-align: right;
}

.btn-box {
  text-align: center;
  margin-top: 20px;
}
</style>
